import React, { useState } from 'react';
import { toVideoEmbedUrl } from '../../../lib/funnelPublicApi';

export default function VSLBlock({ content = {} }) {
  const [playing, setPlaying] = useState(Boolean(content.autoplay));
  const embedUrl = toVideoEmbedUrl(content.video_url);
  const autoplayParam = content.autoplay ? '?autoplay=1' : '';

  return (
    <section className="py-8 px-4 sm:px-0">
      <div className="w-full aspect-video rounded-lg overflow-hidden bg-gray-900 relative">
        {!playing && content.thumbnail_url && embedUrl ? (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            className="absolute inset-0 w-full h-full group"
            aria-label="Play video"
          >
            <img
              src={content.thumbnail_url}
              alt=""
              className="w-full h-full object-cover"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors">
              <span className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center">
                <span className="ml-1 w-0 h-0 border-t-[12px] border-t-transparent border-l-[20px] border-l-[#00AAFF] border-b-[12px] border-b-transparent" />
              </span>
            </span>
          </button>
        ) : embedUrl ? (
          <iframe
            src={`${embedUrl}${autoplayParam}`}
            title="Video presentation"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
            Video not configured
          </div>
        )}
      </div>
      {content.caption && (
        <p className="mt-4 text-center text-gray-600 text-sm sm:text-base leading-relaxed">
          {content.caption}
        </p>
      )}
    </section>
  );
}
